import { Box, Title, Text } from "@mantine/core";
import type { ReactNode } from "react";
import classes from "./page.module.css";

type PageProps = {
  children: ReactNode;
  className?: string;
};

/** AppShell provides the 20px gutter + gray-0; Page is transparent, gap 16. */
export function Page({ children, className }: PageProps) {
  return (
    <Box className={[classes.root, className].filter(Boolean).join(" ")}>
      {children}
    </Box>
  );
}

type PageHeaderProps = {
  breadcrumb?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  extra?: ReactNode;
  /** Vertically centre the title block against `extra` (default: bottom edge). */
  align?: "center";
  className?: string;
};

export function PageHeader({ breadcrumb, title, subtitle, extra, align, className }: PageHeaderProps) {
  return (
    <Box className={[classes.header, className].filter(Boolean).join(" ")}>
      {breadcrumb ? <Box className={classes.breadcrumb}>{breadcrumb}</Box> : null}
      <Box className={classes.headerRow} data-align={align}>
        <Box className={classes.headerLeft}>
          <Title order={1} className={classes.title}>
            {title}
          </Title>
          {subtitle ? <Text className={classes.subtitle}>{subtitle}</Text> : null}
        </Box>
        {extra ? <Box className={classes.extra}>{extra}</Box> : null}
      </Box>
    </Box>
  );
}
